import { gql } from 'graphql-request';

export interface NarrativeFragmentType {
  id: string;
  title: string;
  slug: string;
  publishedAt: string;
  currencyIso: string;
  coverImageUrl: string;
  status: string;
  author: {
    name: string;
    role: string;
    url: string;
    slug: string;
    imageUrl: string;
  };
  contentBlocks: {
    title: string;
    contentHtml: string;
  }[];
  valuations: {
    contentHtml: string;
    title: string;
    fairValue: number;
    sharePriceAtPublish: number;
    type: 'bear' | 'bull' | 'base';
  }[];
  company: {
    id: string;
    canonicalURL: string;
    tickerSymbol: string;
    analysisValue: {
      lastSharePrice: number | null;
      npvPerShare: number | null;
    };
  };
  createdAt: string;
  updatedAt: string;
  voteCount: {
    downvotes: number;
    upvotes: number;
  };
}

export const NARRATIVE_FRAGMENT = gql`
  fragment NarrativeFields on Narrative {
    id
    title
    slug
    publishedAt
    createdAt
    updatedAt
    currencyIso
    status
    author {
      name
      role
      url
      slug
      imageUrl
    }
    contentBlocks {
      title
      contentHtml
    }
    valuations {
      contentHtml
      title
      fairValue
      sharePriceAtPublish
      type
    }
    company {
      id
      analysisValue {
        lastSharePrice
        npvPerShare
      }
      canonicalURL
      tickerSymbol
    }
    voteCount {
      downvotes
      upvotes
    }
  }
`;
